import * as muiGrid from "@material-ui/core/Grid";
import {
  createStyles,
  Theme,
  WithStyles,
  withStyles,
} from "@material-ui/core/styles";
import * as React from "react";

interface Props extends muiGrid.GridProps {}

const styles = (theme: Theme) =>
  createStyles({
    container: {},
  });

export class Grid extends React.PureComponent<
  Props & WithStyles<typeof styles>
> {
  public render() {
    const _props = { ...this.props };

    return <muiGrid.default {..._props} container />;
  }
}

export default withStyles(styles)(Grid);
